<template>
  <!-- affichage du bouton retour -->
  <div class="top-bar">
    <button @click="backPage">Retour</button>
  </div>

  <!-- page revision active -->
  <div class="revision" v-if="activePage == 'revision'">
    <p class="titre2">Liste des plantes</p>
    <input
      @input="searchFilter"
      v-model="search"
      style="margin-left: 5px"
      type="text"
      id="search"
      placeholder="Chercher une plante..."
    />

    <br />

    <ul v-if="searchPlant.length > 0">
      <li v-for="(plant, key) in searchPlant" :key="key">
        <p
          @click="description(plant.id)"
          style="margin-bottom: 5px; cursor: pointer"
        >
          {{ plant.nom }}<br />
          <span class="latin">{{ plant.nomlatin }}</span>
        </p>
      </li>
    </ul>

    <ul v-else>
      <li v-for="(plant, key) in plants" :key="key">
        <p
          @click="description(plant.id)"
          style="margin-bottom: 5px; cursor: pointer"
        >
          {{ plant.nom }}<br />
          <span class="latin">{{ plant.nomlatin }}</span>
        </p>
      </li>
    </ul>
  </div>

  <!-- fiche pour chaque plante -->
  <div class="revision" v-if="activePage == 'description'">
    <p class="titre">{{ plante[0].nom }}</p>

    <swiper
      :direction="horizontal"
      :loop="true"
      navigation
      :autoplay="{ delay: 2500, disableOnInteraction: false }"
    >
      <swiper-slide v-for="(plant, key) in plante[0].image" :key="key">
        <img class="image" :src="'./img/data/' + plant" />
      </swiper-slide>
    </swiper>

    <p>
      <span class="strong" style="text-align=center;">Nom français :</span>
      {{ plante[0].nom }}
    </p>
    <p>
      <span class="strong">Nom latin :</span> <i>{{ plante[0].nomlatin }}</i>
    </p>

    <p v-if="plante[0].toxic == true">
      <span class="strong">Toxique :</span> Oui
    </p>
    <p v-else><span class="strong">Toxique :</span> Non</p>

    <p>
      <span class="strong">Famille :</span>
      {{ getNameOfFamily(plante[0].famille) }}
    </p>

    <span class="strong">Description :</span>
    <p>{{ plante[0].description }}</p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper.min.css";
export default {
  name: "Study",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      //déclaration des variables
      activePage: "revision",
      id: 0,
      plante: [],
      search: "",
      searchPlant: [],
    };
  },
  computed: {
    ...mapGetters({
      plants: "plants",
    }),
  },

  methods: {
    compare(firstElement, secondElement) {
      let firstRegionName = firstElement.nom
        .toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      let secondRegionName = secondElement.nom
        .toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      let comparison = 0;
      if (firstRegionName > secondRegionName) {
        comparison = 1;
      } else if (firstRegionName < secondRegionName) {
        comparison = -1;
      }
      return comparison;
    },
    compareFamily(firstElement, secondElement) {
      let firstRegionName = firstElement.famille
        .toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      let secondRegionName = secondElement.famille
        .toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      let comparison = 0;
      if (firstRegionName > secondRegionName) {
        comparison = 1;
      } else if (firstRegionName < secondRegionName) {
        comparison = -1;
      }
      return comparison;
    },

    //fonction retour pour aller à la page précédente
    backPage() {
      switch (this.activePage) {
        case "revision":
          this.$router.push({ name: "Home" });
          break;
        case "description":
          this.activePage = "revision";
          break;
        case "recherche":
          this.activePage = "revision";
      }
    },

    description(id) {
      //va retourner la plante en paramètre
      let reponse = this.plants.filter((plant) => {
        return id == plant.id;
      });
      this.activePage = "description";
      this.plante = reponse;
    },

    //fonction de recherche
    searchFilter() {
      this.searchPlant = this.plants.filter((plant) => {
        //récupère les données dans la liste plants et retour en temps réel
        return (
          plant.nom.toLowerCase().includes(this.search.toLowerCase()) ||
          plant.nomlatin.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
    getNameOfFamily(family) {
      switch (family) {
        case "1":
          return "Apiacées";
        case "2":
          return "Astéracées";
        case "3":
          return "Fabacées";
        case "4":
          return "Lamiacées";
        case "5":
          return "Rosacées";
        case "6":
          return "Solanacées";
        case "7":
          return "Sapindacées";
        case "8":
          return "Renonculacées";
        case "9":
          return "Caryophyllacées";
        case "10":
          return "Verbénacées";
          break;
        case "11":
          return "Malvacées";
        case "12":
          return "Brassicacées";
        case "13":
          return "Aristolochiacées";
        case "14":
          return "Asparagacées";
        case "15":
          return "Ptéridophytes";
        case "16":
          return "Bétulacées";
        case "17":
          return "Borraginacées";
        case "18":
          return "Poacées";
        case "19":
          return "Cucurbitacées";
        case "20":
          return "Éricacées";
          break;
        case "21":
          return "Cannabinacées";
        case "22":
          return "Fagacées";
        case "23":
          return "Apocynacées";
        case "24":
          return "Caprifoliacées";
        case "25":
          return "Papavéracées";
        case "26":
          return "Rubiacées";
        case "27":
          return "Colchiacées";
        case "28":
          return "Coriariacées";
        case "29":
          return "Plantaginacées";
        case "30":
          return "Célastracées";
          break;
        case "31":
          return "Euphorbiacées";
        case "32":
          return "Polygonacées";
        case "33":
          return "Moracées";
        case "34":
          return "Rhamnacées";
        case "35":
          return "Oléacées";
        case "36":
          return "Géraniacées";
        case "37":
          return "Gymnospermes";
        case "38":
          return "Araliacées";
        case "39":
          return "Hypéricacées";
        case "40":
          return "Lauracées";
          break;
        case "41":
          return "Urticacées";
        case "42":
          return "Phytolaccacées";
        case "43":
          return "Platanacées";
        case "44":
          return "Salicacées";
        case "45":
          return "Rutacées";
        case "46":
          return "Adoxacées";
        case "47":
          return "Smilacées";
        case "48":
          return "Dioscoracées";
        case "49":
          return "Scrofulariacées";
        case "50":
          return "Vitacées";
          break;
      }
    },
  },
};
</script>
